<table class="table participants mb-4" *ngIf="shareHolders.length > 0">
    <thead>
        <tr>
            <th></th>
            <th *ngIf="!owner">{{ 'form.name-shareholder' | translate }}</th>
            <th *ngIf="owner">
                {{ 'form.name-shareholder-legal' | translate }}
            </th>
            <th class="d-none d-md-table-cell">
                {{ 'form.identification' | translate }}
            </th>
            <th class="d-none d-md-table-cell">
                {{ 'form.citizenship' | translate }}
            </th>
            <th class="d-none d-md-table-cell">
                {{ 'form.participation' | translate }}
            </th>
            <th width="90px"></th>
        </tr>
    </thead>
    <tbody>
        <ng-template ngFor let-shareHolder [ngForOf]="shareHolders">
            <tr>
                <td [ngSwitch]="shareHolder.nature">
                    <i class="icon-legal" *ngSwitchCase="Nature.COMPANY"></i>
                    <i class="icon-natural-plus" *ngSwitchDefault></i>
                </td>
                <td>
                    <strong>{{ shareHolder.fullName }}</strong>
                </td>
                <td class="d-none d-md-table-cell">
                    <strong>{{ shareHolder.docId }}</strong>
                </td>
                <td class="d-none d-md-table-cell">
                    <ng-template ngFor let-country [ngForOf]="countries">
                        <strong *ngIf="country.id.value === shareHolder.citizenship">{{ country.name }}</strong>
                    </ng-template>
                </td>
                <td class="d-none d-md-table-cell">
                    <strong>{{ shareHolder.percentage }}%</strong>
                </td>
                <td class="text-right">
                    <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onEdit(shareHolder)" *ngIf="!isDisabled">
                        <i class="icon-edit"></i>
                    </button>
                    <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onRemove(shareHolder)" *ngIf="!isDisabled">
                        <i class="icon-delete"></i>
                    </button>
                </td>
            </tr>
            <ng-template ngFor let-shareHolderFinal [ngForOf]="shareHolder.shareHolders">
                <tr>
                    <td>
                        <i class="icon-natural-plus ml-2"></i>
                    </td>
                    <td>
                        <strong>{{ shareHolderFinal.fullName }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell">
                        <strong>{{ shareHolderFinal.docId }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell">
                        <ng-template ngFor let-country [ngForOf]="countries">
                            <strong *ngIf="country.id.value === shareHolderFinal.citizenship">{{ country.name }}</strong>
                        </ng-template>
                    </td>
                    <td class="d-none d-md-table-cell"></td>
                    <td class="text-right"></td>
                </tr>
            </ng-template>
        </ng-template>
    </tbody>
</table>
